import * as ACTION from './constants';

// ACTION CREATORS
export const formBase = () => ({ type: ACTION.FORM_BASE });
export const isSubmitted = () => ({ type: ACTION.FORM_SUBMITTED });
export const setForm = (form = null, initial = false) => ({ type: ACTION.FORM_SET, form, initial });

export const setClassSets = (template) => (dispatch, getState) => {
  const classForm = getState().classFormState.form;
  classForm.sets = template.sets;
  dispatch(setForm(classForm));
}

export const setExercises = (data) => (dispatch, getState) => {
  const classForm = getState().classFormState.form;
  for(let i = 0; i < classForm.sets.length; i++) {
    const setObj = classForm.sets[i];
    const activities = setObj["activities"];
    for(let j = 0; j < activities.length; j++) {
      const activityObj = activities[j];
      if(activityObj.exercise) {
        for (const item of data) {
          if(activityObj.exercise.id === item.id) {
            activityObj.exercise = item;
          }
        }
      }
    }
  }

  dispatch(setForm(classForm));
}

export const updateExercise = (data) => (dispatch, getState) => {
  const classForm = getState().classFormState.form;
  for(let i = 0; i < classForm.sets.length; i++) {
    const setObj = classForm.sets[i];
    const activities = setObj["activities"];
    for(let j = 0; j < activities.length; j++) {
      const activityObj = activities[j];
      if(activityObj.exercise && activityObj.exercise.id === data.id) {
        activityObj.exercise = data;
      }
    }
  }

  dispatch(setForm(classForm));
}
